import {createSlice,createAsyncThunk} from "@reduxjs/toolkit"
import { filterUrls } from "../../../services/api.enums";
import { filterTableDataAPI } from "../../../services/CRUDServices";
import { ErrorAlert } from "global/alert/Alert";



export const filterDock=createAsyncThunk('docklists',async(body:any)=>{

    var data:any;
    try {
      data = await filterTableDataAPI(filterUrls.dock as any, body?.pageNumber || 1,{
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },true);
      } catch (error) {
        ErrorAlert(error?.response?.data?.errors?.message)
      }
    return data.data;
})

const initialState:any= {
    dockLists:[],
    fetchpost:false,
    errorMessage:null,
    isUpdating: false,
    filter:{}    
}

const DockLists= createSlice({
    initialState: initialState,
    name: "gateLists",
    reducers: {
          clearDock: (state) => {
            state.dockLists = [];
          },
          setFilter: (state, action) => {
            state.filter = action.payload;
          },
    },
    extraReducers: {
        [filterDock.fulfilled as any]: (state, action) => {
            state.dockLists = action.payload.payload;
            state.fetchPost = false;
        },
        [filterDock.pending as any]: (state) => {
            state.fetchPost = true;
        },
        [filterDock.rejected as any]: (state) => {
            state.fetchPost = false;
            state.errorMessage = "wrong";
        },
    },
});

export const {  setFilter ,clearDock} = DockLists.actions;
export default DockLists.reducer